import { SEO } from "../seo/SEO";
import { BrandLockup } from "../components/audios/BrandLockup";

export default function Error404() {
  return (
    <>
      <SEO title="Error 404" description="Página no encontrada" />
      <section
        className="flex flex-col justify-center items-center min-h-screen px-6"
        style={{ background: "#160e2f" }}
      >
        <div className="flex flex-col items-center max-w-xl w-full">
          <h2 className="text-white/50 lg:text-5xl sm:text-4xl text-3xl font-medium">ERROR</h2>
          <h1 className="text-white font-bold lg:text-[180px] sm:text-[160px] text-8xl text-center leading-none">
            404
          </h1>
          <h3 className="text-white/60 lg:text-2xl sm:text-2xl text-lg font-medium sm:mb-12 mb-8 text-center">
            No se encontró la página.
          </h3>

          <a
            href="/"
            className="rounded-full font-semibold px-8 h-11 flex items-center justify-center text-white transition-colors ease-in duration-300"
            style={{ background: "#e0217a" }}
          >
            Ir al inicio
          </a>

          <BrandLockup size="sm" className="bg-white/95 rounded-lg px-2.5 py-1.5 mt-14" />
        </div>
      </section>
    </>
  );
}
